import { render } from "./MaterialInput.vue?vue&type=template&id=9ac6eb9c&scoped=true"
import script from "./MaterialInput.vue?vue&type=script&lang=js"
export * from "./MaterialInput.vue?vue&type=script&lang=js"

import "./MaterialInput.vue?vue&type=style&index=0&id=9ac6eb9c&lang=scss&scoped=true"

import exportComponent from "/Users/hanssagita/Documents/freelance/gunsa2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ac6eb9c"]])

export default __exports__